import APIService from '@/services/APIService.js';

export default {
  getAll(includeExpiredRecords) {
    return APIService.apiCall().get(`/projecoesBrr/get-all/${includeExpiredRecords}`);
  },
  getById(id) {
    return APIService.apiCall().get(`/projecoesBrr/get-by-id/${id}`);
  },
  getByStatus(status) {
    status = status.toUpperCase();
    return APIService.apiCall().get(`/projecoesBrr/get-by-status/${status}`);
  },
  salvar(postData) {
    return APIService.apiCall().post(`/projecoesBrr/salvar/${postData.id}`, JSON.stringify(postData));
  },
  executar(id) {
    return APIService.apiCall().get(`/projecoesBrr/executar/${id}`);
  },
  duplicar(id) {
    return APIService.apiCall().get(`/projecoesBrr/duplicar/${id}`);
  },
  deletar(id) {
    return APIService.apiCall().get(`/projecoesBrr/excluir/${id}`);
  },
  getUltimoIpca() {
    return APIService.apiCall().get('/projecoesBrr/get-ultimo-ipca');
  },
  validaIpcaArquivoCapex(postData) {
    return APIService.apiCall().post('/projecoesBrr/validaIpcaArquivoCapex', JSON.stringify(postData));
  },
  validaArquivoIpca(postData) {
    return APIService.apiCall().post('/projecoesBrr/valida-arquivo-ipca', JSON.stringify(postData));
  },
  download(id, config = {}) {
    return APIService.apiCall().get(`/projecoesBrr/baixar-arquivo-resultado/${id}`, {
      responseType: 'blob',
      ...config
    });
  },
  baixarLogsTecnicos(id) {
    return APIService.apiCall().get(`/projecoesBrr/baixar-logs-tecnicos/${id}`, {
      responseType: 'blob',
      ...{
        timeout: 60 * 60 * 1000
      }
    });
  },
  getArquivoModeloCapex(dataBaseAis, dataSimulacao) {
    return APIService.apiCall().get(`projecoesBrr/baixar-arquivo-modelo-capex/${dataBaseAis}/${dataSimulacao}`, {
      responseType: 'blob',
      ...{
        timeout: 60 * 60 * 1000
      }
    });
  },
  getArquivoModeloIpca(projecao) {
    return APIService.apiCall().get(`projecoesBrr/baixar-arquivo-modelo-ipca/${projecao}`, {
      responseType: 'blob',
      ...{
        timeout: 60 * 60 * 1000
      }
    });
  }
};
